export default "__VITE_ASSET__65ff2a37__"